<template>
    <div class="container">
        <div>
            <div class="content" v-watermark>
                <div class="header">
                    <div class="title">
                        <span class="bold">会诊记录</span>
                    </div>
                </div>
                <van-row>
                    <van-col span="24">
                        <span>会诊单号：</span>
                        <span>{{ data.consultationNo }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>申请时间：</span>
                        <span>{{ data.applyTime }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>申请人：</span>
                        <span>{{ data.applyDoctorName}}</span>
                    </van-col>
                    <van-col span="24">
                        <span>会诊分类：</span>
                        <span>{{ data.classify | classifyFilter(data.classify) }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>会诊人：</span>
                        <span>{{ data.memberName }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>性别：</span>
                        <span>{{ data.memberSex | sexFilter(data.memberSex)  }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>年龄：</span>
                        <span>{{ data.memberAge + "岁" }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>电话：</span>
                        <span>{{ data.memberMobile }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>就诊号：</span>
                        <span>{{ data.askNo }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>患者现病情及申请目的：</span>
                        <span>{{ data.purpose }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>会诊结论/治疗措施</span>
                        <span>{{ data.conclusion }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>会诊医生：</span>
                        <span>{{ data.consultationDoctorName }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>完成时间：</span>
                        <span>{{ data.completeTime }}</span>
                    </van-col>
                </van-row>
            </div>
        </div>    
        <prev-page :text="'返回首页'" @back="back"></prev-page>
    </div>
</template>
<script>
import request from '@/utils/request.js'
export default {
    data() {
        return {
            no: "",
            data: {},
        };
    },
    created() {
        this.no = this.$route.query.no;
        this.getRecordDetails();
    },
    methods: {
        getRecordDetails() {
            request({
                url: `/doctor-service/doctorConsultation/detail/${this.no}`,
                method: 'get',
            }).then((res) => {
                this.data = res.data;
            }).catch(() => {
                
            })
        },
        back() {
            this.$router.back();
        },
    },
};
</script>
<style lang="scss" scoped>
.container {
    padding: 10px;
    padding-bottom: 90px;

    .content {
        background: #fff;
        padding: 0 26px;
        border-radius: 4px;
        margin-bottom: 10px;

        &:last-child {
            padding-bottom: 12px;
        }

        .header {
            padding: 22px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            .title {
                display: flex;
                align-items: center;
                .bold {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                }
                .desc {
                    color: #ee9e2e;
                    margin-left: 5px;
                    font-size: 14px;
                }
            }
        }

        :deep() .van-col {
            font-size: 14px;
            margin-bottom: 14px;

            span {
                &:first-child {
                    color: #999;
                    margin-right: 20px;
                }
                word-break: break-all;
            }
        }

        :deep() .van-cell {
            padding: 0;
            font-size: 14px;

            .van-cell__title {
                margin-right: 20px;
                width: auto;
            }

            .van-cell__value {
                background: #f6fbff;
                padding: 0 10px;
            }

            &::after {
                border: none;
            }
        }

        .footer {
            display: flex;
            justify-content: flex-end;
            padding: 20px 0 26px 0;
        }
    }
}

// .van-row {
//     display: flex;
//     flex-direction: column;
// }
</style>
